import { createFileRoute } from '@tanstack/react-router';

import { KickwordForm } from './-components/KickwordForm';

export const Route = createFileRoute('/_authenticated/kickwords/new')({
    component: KickwordForm,
});
